import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Breadcrumb,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

import messages from "../../redux/messages";
import SidebarDashboard from "../../components/SidebarDashboard";
import {
  deleteRequirementsMonitor,
  editRequirementsMonitor,
  getRequirementsMonitor,
  saveRequirementsMonitor,
  deleteRequirementsUrl,
  // getRequirementsUrls,
  // saveRequirementsUrl,
} from "../../redux/seleccionContratacion/RequirementsMonitor/actions";
import { getPaises } from "../../redux/seleccionContratacion/pais/actions";
import { Typeahead } from "react-bootstrap-typeahead";
import { get_tasks_descriptors } from "../../redux/tasks/actions";
import { getEstados } from "../../redux/seleccionContratacion/estados/actions";
import { getMotivos } from "../../redux/seleccionContratacion/motivo/actions";
import LinkDescargaRequirement from "../../components/seleccionContratacion/LinkDescargaRequirement";
import { getEmployeesResponsible } from "../../redux/capacitacionDesarrollo/TrainingEvents/actions";
import { getDescriptorValidation } from "../../redux/descriptorsProfiles/DescriptorValidation/actions";
import config from "../../config";

const returnData = (value) => {
  var _list = [];
  value.map((item) => {
    _list = [
      ..._list,
      { id: item.division, label: item.division__descripcion },
    ];
  });
  return _list;
};

const RequirementsMonitor = (props) => {
  const filters = [
    { id: "departamento_nombre", desc: "División" },
    { id: "jefe", desc: "Creado por" },
    { id: "fecha_solicitud", desc: "Fecha solicitud" },
    { id: "estado_nombre", desc: "Estado" },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [funSelected, setFunSelected] = useState([]);
  const [depSelected, setDepSelected] = useState([]);
  const [download, setDownload] = useState(null);
  const [downloadEdit, setDownloadEdit] = useState(null);
  const [_funcion, setFuncion] = useState(false);
  const [_continue, setContinue] = useState(true);
  const [empSelected, setEmpSelected] = useState([]);
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  const [view, setView] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();

  const schema = Yup.object().shape({
    funcion: Yup.string().required("**Campo requerido"),
    departamento: Yup.string().required("**Campo requerido"),
    pais: Yup.string().required("**Campo requerido"),
    motivo: Yup.string().required("**Campo requerido"),
    numero_posiciones: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(0, "El valor minimo es 0.")
      .max(10, "El valor maximo es 10.")
      .required("**Campo requerido"),
    estado: Yup.string().when("isBoss", {
      is: false,
      then: Yup.string().required("**Campo requerido"),
    }),
    plan_induccion: Yup.string().when("edit", {
      is: () => !edit || (edit && !editItem.list_plan_induccion),
      then: Yup.string().required("**Campo requerido"),
    }),
    responsable_seguimiento_plaza: Yup.string()
      .ensure()
      .required("**Campo requerido"),
  });

  const { userRoles } = useSelector((store) => store.auth);

  const {
    loading,
    saveLoading,
    requirementsMonitorsLength,
    requirementsMonitors,
    requirementsMonitorError,
    formError,
  } = useSelector((store) => store.requirementsMonitor);

  const pages = Math.ceil(requirementsMonitorsLength / limit);

  const { loaderPaises, paises, paisesFalla } = useSelector(
    (store) => store.paises
  );

  const tasks = useSelector((store) => store.tasks.tasks);
  const tasksLoader = useSelector((store) => store.tasks.loader);

  const { unidOrg } = useSelector((store) => store.auth);

  const {
    loading: descriptorValidationLoading,
    descriptorExist,
    descriptorComplete,
    menssege,
    divisions,
  } = useSelector((store) => store.descriptorValidation);

  const { estados, loaderEstados, estadosFalla } = useSelector(
    (store) => store.estados
  );

  const { loaderMotivos, motivos, motivosFalla } = useSelector(
    (store) => store.motivos
  );

  const { loaderPersonResponsible, personResponsible } = useSelector(
    (store) => store.trainingEvents
  );

  let employeesOptions = [];
  personResponsible &&
    personResponsible.data.map((item) => {
      employeesOptions = [
        ...employeesOptions,
        {
          id: item.list_username[0].id,
          label: `${item.list_username[0].username} / ${item.list_username[0].first_name} ${item.list_username[0].last_name}`,
          item: item.list_username[0],
        },
      ];
    });

  let funcionOptions = [];
  tasks &&
    tasks.map((task) => {
      funcionOptions = [
        ...funcionOptions,
        {
          id: task.id,
          label: task.descripcion
            ? `${task.codigo} / ${task.descripcion.toUpperCase()}`
            : "",
          item: task,
        },
      ];
    });

  let motiveOptions = [];
  motivos &&
    motivos.data.map((motive) => {
      motiveOptions = [
        ...motiveOptions,
        {
          id: motive.id,
          label: motive.descripcion,
        },
      ];
    });

  let estadoOptions = [];
  estados &&
    estados.data.map((estdo) => {
      if (parseInt(estdo.tipo_estado) === 1) {
        estadoOptions = [
          ...estadoOptions,
          {
            id: estdo.id,
            label: estdo.nombre_estado,
          },
        ];
      }
    });

  const columns = [
    {
      Header: "División:",
      // accessor: "list_division[0].list_departamento[0].descripcion",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.departamento
            ? value.row.original.list_departamento[0].descripcion
            : ""}
        </div>
      ),
    },
    {
      Header: "Cod. posición:",
      // accessor: "list_puesto[0].codigo",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_puesto[0].codigo
            ? value.row.original.list_puesto[0].codigo
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Posición:",
      // accessor: "list_puesto[0].descripcion",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_puesto[0].descripcion
            ? value.row.original.list_puesto[0].descripcion
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Creado por:",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex justify-content-between">
          <p>
            {value.row.original.list_creador_plaza[0].last_name
              ? `${value.row.original.list_creador_plaza[0].first_name} ${value.row.original.list_creador_plaza[0].last_name}`
              : value.row.original.list_creador_plaza[0].first_name}
          </p>
        </div>
      ),
    },
    {
      Header: "Responsable:",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex justify-content-between">
          <p>
            {value.row.original.list_responsable_seguimiento_plaza
              ? value.row.original.list_responsable_seguimiento_plaza[0]
                  .last_name
                ? `${value.row.original.list_responsable_seguimiento_plaza[0].first_name} ${value.row.original.list_responsable_seguimiento_plaza[0].last_name}`
                : value.row.original.list_responsable_seguimiento_plaza[0]
                    .first_name
              : "No ingresado"}
          </p>
        </div>
      ),
    },
    {
      Header: "Fecha solicitud:",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_solicitud).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      Header: "Estado:",
      // accessor: "list_estado[0].nombre_estado",
      Filter: "",
      Cell: (value) => (
        <div
          className="p-2 rounded-pill text-white text-center"
          style={{
            backgroundColor: value.row.original.list_estado[0].color_mostrar,
            minWidth: "90px",
          }}
        >
          {value.row.original.list_estado[0].nombre_estado}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Editar solicitud</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>
          {view === "administrador" &&
            props.match.params.type === "plazas-vacantes" && (
              <Button
                size="sm"
                className="text-danger"
                variant="link"
                type="button"
                // disabled={
                //   value.row.original.estado &&
                //   value.row.original.list_estado[0].nombre_estado.toLowerCase() ===
                //     "cerrado"
                // }
                onClick={() => onDelete(value.row.original.id, value.row.index)}
              >
                <i className="material-icons">close</i>
              </Button>
            )}
          <LinkDescargaRequirement id={value.row.original.id} />
          {value.row.original.list_plan_induccion &&
            value.row.original.list_plan_induccion.length > 0 && (
              <>
                {value.row.original.list_plan_induccion.map((url) => (
                  <>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>
                          Descargar {url.nombre_archivo}
                        </Tooltip>
                      }
                    >
                      <Button
                        size="sm"
                        className="text-secondary"
                        variant="link"
                        type="button"
                        disabled={
                          download !== null &&
                          parseInt(download) === parseInt(value.row.index)
                        }
                        onClick={() => {
                          setDownload(parseInt(value.row.index));
                          setTimeout(() => {
                            var element = document.createElement("a");
                            element.setAttribute(
                              "href",
                              // "data:text/plain;charset=utf-8," +
                              // encodeURIComponent(
                              `${process.env.REACT_APP_URL}/media/${url.plan_induccion}`
                              // )
                            );
                            element.setAttribute(
                              "download",
                              `${url.nombre_archivo}`
                            );
                            element.style.display = "none";
                            document.body.appendChild(element);
                            element.click();
                            document.body.removeChild(element);
                            setDownload(null);
                          }, 500);
                        }}
                      >
                        {download !== null &&
                        parseInt(download) === parseInt(value.row.index) ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <i className="material-icons">plagiarism</i>
                        )}
                      </Button>
                    </OverlayTrigger>
                  </>
                ))}
              </>
            )}
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Ir al seguimiento</Tooltip>}
          >
            <Button
              size="sm"
              className="text-info"
              variant="link"
              type="button"
              onClick={() =>
                history.push(
                  `/seleccion-contratacion/seguimiento-solitudes/${props.match.params.type}/${props.match.params.id}/${props.match.params.nombrePuesto}/${props.match.params.codigo}/${value.row.original.id}/${props.match.params.rol}`
                )
              }
            >
              <i className="material-icons">double_arrow</i>
            </Button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  // Métodos
  const _getRequirementsMonitor = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getRequirementsMonitor({
        offset: offs,
        limit: lim,
        tipo_busqueda: "posicion_id",
        filter: parseInt(props.match.params.id),
        tipo_busqueda_2: tipoBusqueda.id,
        filter_2: filt,
      })
    );

  useEffect(() => {
    if (
      props.match.params.rol &&
      config.roles.find((rol) => rol.abrev === props.match.params.rol)
    ) {
      setView(
        config.roles.find((rol) => rol.abrev === props.match.params.rol).rol
      );
    } else {
      setView("");
    }
  }, [props.match.params.rol]);

  useEffect(() => {
    _getRequirementsMonitor();
    dispatch(getPaises({}));
    // dispatch(get_tasks({}));
    dispatch(
      get_tasks_descriptors(
        {
          unidad_organizativa: unidOrg,
        },
        2
      )
    );
    dispatch(getEstados({}));
    dispatch(getMotivos({}));
    
  }, []);

  useEffect(() => {
    let filters = {
      filter: "Responsable_Seleccion_Contratacion"
    }
    if(userRoles.includes("Responsable_Seleccion_Contratacion")){
      filters.usuario_x_empresa = "si"
    }
    dispatch(getEmployeesResponsible(filters));
  }, [userRoles]);

  const ToggleableLink = (props) => {
    const { disabled, ...rest } = props;
    return disabled ? (
      <div
        className="btn btn-light rounded-pill"
        style={{ pointerEvents: "none", opacity: "0.8" }}
        disabled
      >
        {props.children}
      </div>
    ) : (
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip style={{ zIndex: 999999999999 }} {...props}>
            Descriptores de la función
          </Tooltip>
        }
      >
        <Link
          {...rest}
          className="btn btn-light rounded-pill d-flex flex-wrap justify-content-center align-items-center"
          style={{ textDecoration: "none" }}
          to={`/descriptores-perfiles/seleccion-del-descriptor/${
            funSelected.length > 0 ? funSelected[0].id : ""
          }/${funSelected.length > 0 ? funSelected[0].item.descripcion : ""}`}
          // target="_blank"
        >
          {props.children}
        </Link>
      </OverlayTrigger>
    );
  };

  const onAdd = () => {
    dispatch(getDescriptorValidation(null));
    setEmpSelected([]);
    setFunSelected([]);
    setDepSelected([]);
    setFuncion(false);
    setShowModal(true);
    setEdit(false);
    setValidated(false);
    setContinue(true);
  };

  const onEdit = (item, index) => {
    if (item.responsable_seguimiento_plaza) {
      setEmpSelected([
        {
          id: item.responsable_seguimiento_plaza,
          label: `${item.list_responsable_seguimiento_plaza[0].username} / ${item.list_responsable_seguimiento_plaza[0].first_name} ${item.list_responsable_seguimiento_plaza[0].last_name}`,
          item: item.list_responsable_seguimiento_plaza[0],
        },
      ]);
    }
    if (item.funcion) {
      setFunSelected([
        {
          id: item.funcion,
          label: item.list_funcion[0].descripcion
            ? `${
                item.list_funcion[0].codigo
              } / ${item.list_funcion[0].descripcion.toUpperCase()}`
            : "",
          item: item.list_funcion[0],
        },
      ]);
      setFuncion(true);
      dispatch(getDescriptorValidation(item.list_funcion[0]));
    }
    if (item.departamento) {
      setDepSelected([
        {
          id: item.departamento,
          label: item.list_departamento[0].descripcion,
        },
      ]);
    } else {
      setDepSelected([]);
    }
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
    setContinue(true);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    debugger;
    _getRequirementsMonitor(
      oOffset,
      limit,
      tipoBusqueda.id === "fecha_solicitud"
        ? moment(e.target.filter.value.split("/").reverse().join("-")).format(
            "YYYY-MM-DD"
          )
        : e.target.filter.value
    );
  };

  const onSubmit = async (req) => {
    const _req = new FormData();
    _req.append("funcion", parseInt(req.funcion));
    _req.append("departamento", parseInt(req.departamento));
    _req.append("pais", parseInt(req.pais));
    _req.append("motivo", parseInt(req.motivo));
    _req.append(
      "responsable_seguimiento_plaza",
      parseInt(req.responsable_seguimiento_plaza)
    );
    _req.append("numero_posiciones", 1);
    _req.append("posicion", parseInt(props.match.params.id));

    if (!edit) {
      const openState = estadoOptions.find(
        (it) => it.label.toLowerCase() === "abierto"
      );
      if (openState) {
        _req.append("estado", parseInt(openState.id));
      } else {
        toastr.error(
          'No se encontro el estado "abierto", favor contacte al administrador'
        );
        return;
      }
      dispatch(
        saveRequirementsMonitor(
          _req,
          setShowModal,
          document.getElementById("plan_induccion").files,
          _getRequirementsMonitor
        )
      );
    } else {
      _req.append("estado", parseInt(req.estado));
      dispatch(
        editRequirementsMonitor(
          _req,
          editItem,
          parseInt(req.estado),
          index,
          setShowModal,
          document.getElementById("plan_induccion").files,
          _getRequirementsMonitor
        )
      );
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getRequirementsMonitor(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteRequirementsMonitor(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onDeleteUrl = (id, index, _index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteRequirementsUrl(id, index, _index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="mb-4 px-2">
            <div className="d-flex flex-wrap justify-content-start align-items-center">
              <Button
                onClick={() =>
                  history.push(
                    `/seleccion-contratacion/${props.match.params.type}`
                  )
                }
                variant="link"
                className="font-weight-bold mr-4 text-dark"
              >
                <i className="material-icons">arrow_back</i>
              </Button>
              <Breadcrumb className="pb-0">
                <Breadcrumb.Item
                  title
                  onClick={() =>
                    history.push(
                      `/seleccion-contratacion/${props.match.params.type}`
                    )
                  }
                >
                  Puestos
                </Breadcrumb.Item>
                <Breadcrumb.Item active title>
                  Seguimiento de solicitudes
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <hr />
          </div>
          <div className="my-1 pl-md-4 pr-md-3 px-2 d-flex flex-wrap justify-content-between align-items-center">
            <Row className="justify-content-end align-items-center flex-nowrap">
              <h6 className="font-weight-bold text-uppercase">
                {props.match.params.nombrePuesto.replaceAll("-", "/")}
              </h6>
            </Row>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    type="search"
                    //type={tipoBusqueda.id === 'fecha_solicitud' ? 'date' : 'search'}
                    pattern={
                      tipoBusqueda.id === "fecha_solicitud"
                        ? "(?:((?:0[1-9]|1[0-9]|2[0-9])/(?:0[1-9]|1[0-2])|(?:30)/(?!02)(?:0[1-9]|1[0-2])|31/(?:0[13578]|1[02]))/(?:19|20)[0-9]{2})"
                        : null
                    }
                    placeholder={
                      tipoBusqueda.id === "fecha_solicitud"
                        ? "dd/mm/aaaa"
                        : "Buscar"
                    }
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    {props.match.params.type === "plazas-vacantes" ? (
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Agregar solicitud</Tooltip>
                        }
                      >
                        <Button
                          variant="light"
                          size="sm"
                          className="rounded-circle"
                          onClick={() => onAdd()}
                        >
                          <i className="material-icons">add</i>
                        </Button>
                      </OverlayTrigger>
                    ) : null}
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Ir al Historial de Puesto</Tooltip>
                      }
                    >
                      <Button
                        variant="light"
                        size="sm"
                        className="rounded-circle"
                        onClick={() =>
                          history.push(
                            `/seleccion-contratacion/positionHistory/${props.match.params.type}/${props.match.params.id}/${props.match.params.nombrePuesto}/${props.match.params.codigo}/${props.match.params.rol}`
                          )
                        }
                      >
                        <i className="material-icons">library_books</i>
                      </Button>
                    </OverlayTrigger>

                    <Dropdown className="ml-1 mr-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {!!requirementsMonitorError && (
            <Alert variant="danger" className="mt-4 mb-1">
              {requirementsMonitorError}
            </Alert>
          )}
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            requirementsMonitorsLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={requirementsMonitors}
                    />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={requirementsMonitorsLength}
                  pages={pages}
                  pagFunc={_getRequirementsMonitor}
                />
              </>
            )
          )}
          {!loading &&
            requirementsMonitorsLength === 0 &&
            requirementsMonitorError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            funcion: edit ? editItem.funcion : "",
            departamento: edit ? editItem.departamento : "",
            pais: edit ? editItem.pais : "",
            motivo: edit ? editItem.motivo : "",
            numero_posiciones: 1,
            estado: edit
              ? editItem.estado
              : estados && estados.data.length > 0
              ? estados.data
                  .find((e) => e.nombre_estado.toLowerCase() === "abierto")
                  .id.toString()
              : "",
            plan_induccion: "",
            isBoss: view === "jefe",
            responsable_seguimiento_plaza: edit
              ? editItem.responsable_seguimiento_plaza
              : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar solicitud" : "Crear solicitud"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="my-1">
                    {formError}
                  </Alert>
                )}
                {!descriptorExist ? (
                  <div className="my-1 border-left border-danger">
                    <Alert variant="light">
                      <p>
                        No existe un descriptor para esta función, ¿Desea
                        agregar uno,{" "}
                        <Link
                          to={`/descriptores-perfiles/seleccion-del-descriptor/${
                            funSelected.length > 0 ? funSelected[0].id : ""
                          }/${
                            funSelected.length > 0
                              ? funSelected[0].item.descripcion
                              : ""
                          }`}
                        >
                          si
                        </Link>{" "}
                        o{" "}
                        <Link
                          onClick={() => {
                            dispatch(getDescriptorValidation(null));
                          }}
                        >
                          no
                        </Link>
                        ?
                      </p>
                    </Alert>
                  </div>
                ) : null}
                {!descriptorComplete ? (
                  <div className="my-1 border-left border-danger">
                    <Alert variant="light">
                      <p>
                        El descriptor para esta función no está completo,{" "}
                        {menssege.toLowerCase()}, ¿Desea completarlo ahora,{" "}
                        <Link
                          to={`/descriptores-perfiles/seleccion-del-descriptor/${
                            funSelected.length > 0 ? funSelected[0].id : ""
                          }/${
                            funSelected.length > 0
                              ? funSelected[0].item.descripcion
                              : ""
                          }`}
                        >
                          si
                        </Link>{" "}
                        o{" "}
                        <Link
                          onClick={() => {
                            dispatch(getDescriptorValidation(null));
                          }}
                        >
                          no
                        </Link>
                        ?
                      </p>
                    </Alert>
                  </div>
                ) : null}
                {!_continue ? (
                  <div className="my-1 border-left border-danger">
                    <Alert variant="light">
                      <p>Seleccione otra función para poder continuar.</p>
                    </Alert>
                  </div>
                ) : null}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Función
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={10}>
                        <Typeahead
                          id="funcion"
                          name="funcion"
                          isInvalid={touched.funcion && errors.funcion}
                          isValid={touched.funcion && !errors.funcion}
                          onBlur={handleBlur("funcion")}
                          placeholder="Seleccione una función"
                          options={funcionOptions}
                          onChange={(selected) => {
                            setFieldValue(
                              "funcion",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setFunSelected(selected);
                            setFuncion(selected.length > 0);
                            dispatch(
                              getDescriptorValidation(selected[0], true)
                            );
                          }}
                          selected={funSelected}
                          disabled={
                            tasks.length === 0 ||
                            (edit &&
                              editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado") ||
                            props.match.params.type === "plazas-no-vacantes"
                          }
                        ></Typeahead>
                      </Col>
                      {tasksLoader || descriptorValidationLoading ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : (
                        <Col
                          sm={1}
                          className="d-flex flex-wrap justify-content-center align-items-center"
                        >
                          <ToggleableLink
                            disabled={
                              !_funcion ||
                              (edit &&
                                editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                  "cerrado") ||
                              props.match.params.type === "plazas-no-vacantes"
                            }
                          >
                            <i className="material-icons">description</i>
                          </ToggleableLink>
                        </Col>
                      )}
                    </Row>
                    {touched.funcion && errors.funcion && (
                      <Col>
                        <small className="text-danger">{errors.funcion}</small>
                      </Col>
                    )}
                    {!tasksLoader && tasks.length === 0 && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron funciones
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    División
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={descriptorValidationLoading ? "10" : "12"}>
                        <Typeahead
                          id="departamento"
                          name="departamento"
                          isInvalid={
                            touched.departamento && errors.departamento
                          }
                          isValid={touched.departamento && !errors.departamento}
                          onBlur={handleBlur("departamento")}
                          placeholder="Seleccione una división"
                          options={
                            divisions.length > 0 ? returnData(divisions) : []
                          }
                          onChange={(selected) => {
                            setFieldValue(
                              "departamento",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setDepSelected(selected);
                          }}
                          selected={depSelected}
                          disabled={
                            divisions.length === 0 ||
                            (edit &&
                              editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado") ||
                            props.match.params.type === "plazas-no-vacantes"
                          }
                        ></Typeahead>
                      </Col>
                      {descriptorValidationLoading && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.departamento && errors.departamento && (
                      <Col>
                        <small className="text-danger">
                          {errors.departamento}
                        </small>
                      </Col>
                    )}
                    {!descriptorValidationLoading &&
                    divisions.length === 0 &&
                    _funcion ? (
                      <Col>
                        <small className="text-danger">
                          **No hay divisiones asociadas a esta función.
                        </small>
                      </Col>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Pais
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loaderPaises ? "10" : "12"}>
                        <Form.Control
                          disabled={
                            (paises && paises.count === 0) ||
                            (edit &&
                              editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado") ||
                            props.match.params.type === "plazas-no-vacantes"
                          }
                          as="select"
                          id="pais"
                          name="pais"
                          className="col rounded-pill"
                          onBlur={handleBlur("pais")}
                          value={values.pais}
                          onChange={handleChange}
                          isValid={touched.pais && !errors.pais}
                          isInvalid={touched.pais && !!errors.pais}
                        >
                          <option key="" value="" selected disabled>
                            Seleccione un pais
                          </option>
                          {paises &&
                            paises.count > 0 &&
                            paises.data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre_pais}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loaderPaises && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.pais && errors.pais && (
                      <Col>
                        <small className="text-danger">{errors.pais}</small>
                      </Col>
                    )}
                    {!!paisesFalla && (
                      <Col>
                        <small className="text-danger">**{paisesFalla}</small>
                      </Col>
                    )}
                    {!loaderPaises && paises && paises.count === 0 && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron paises
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-md-1">
                  <Form.Label column sm={3}>
                    Motivo plaza vacante
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loaderMotivos ? "10" : "12"}>
                        <Form.Control
                          disabled={
                            (motivos && motivos.count === 0) ||
                            (edit &&
                              editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado") ||
                            props.match.params.type === "plazas-no-vacantes"
                          }
                          as="select"
                          id="motivo"
                          name="motivo"
                          className="col rounded-pill"
                          onBlur={handleBlur("motivo")}
                          value={values.motivo}
                          onChange={handleChange}
                          isValid={touched.motivo && !errors.motivo}
                          isInvalid={touched.motivo && !!errors.motivo}
                        >
                          <option key="" value="" selected disabled>
                            Seleccione el motivo de plaza vacante
                          </option>
                          {motiveOptions &&
                            motiveOptions.length > 0 &&
                            motiveOptions.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.label}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loaderMotivos && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.motivo && errors.motivo && (
                      <Col>
                        <small className="text-danger">{errors.motivo}</small>
                      </Col>
                    )}
                    {!!motivosFalla && (
                      <Col>
                        <small className="text-danger">**{motivosFalla}</small>
                      </Col>
                    )}
                    {!loaderMotivos && motivos && motivos.count === 0 && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron motivos de plazas vacantes
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Responsable
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loaderPersonResponsible ? "10" : "12"}>
                        <Typeahead
                          id="responsable_seguimiento_plaza"
                          name="responsable_seguimiento_plaza"
                          isInvalid={
                            touched.responsable_seguimiento_plaza &&
                            errors.responsable_seguimiento_plaza
                          }
                          isValid={
                            touched.responsable_seguimiento_plaza &&
                            !errors.responsable_seguimiento_plaza
                          }
                          onBlur={handleBlur("responsable_seguimiento_plaza")}
                          placeholder="Seleccione un responsable"
                          options={employeesOptions}
                          onChange={(selected) => {
                            setFieldValue(
                              "responsable_seguimiento_plaza",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setEmpSelected(selected);
                          }}
                          selected={empSelected}
                          disabled={
                            loaderPersonResponsible ||
                            employeesOptions.length === 0 ||
                            (edit &&
                              editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado") ||
                            props.match.params.type === "plazas-no-vacantes"
                          }
                        ></Typeahead>
                      </Col>
                      {loaderPersonResponsible && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.responsable_seguimiento_plaza &&
                      !!errors.responsable_seguimiento_plaza && (
                        <div className="px-2">
                          <small className="text-danger">
                            {errors.responsable_seguimiento_plaza}
                          </small>
                        </div>
                      )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-md-1">
                  <Form.Label column sm={3}>
                    Número de posiciones
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.Control
                          id="numero_posiciones"
                          name="numero_posiciones"
                          disabled
                          isInvalid={
                            touched.numero_posiciones &&
                            errors.numero_posiciones
                          }
                          isValid={
                            touched.numero_posiciones &&
                            !errors.numero_posiciones
                          }
                          onBlur={handleBlur("numero_posiciones")}
                          onChange={handleChange}
                          value={values.numero_posiciones}
                          className="rounded-pill"
                          type="number"
                          placeholder="0"
                          min={0}
                          max={10}
                          step={1}
                        ></Form.Control>
                      </Col>
                    </Row>
                    {touched.numero_posiciones && errors.numero_posiciones && (
                      <Col>
                        <small className="text-danger">
                          {errors.numero_posiciones}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Estado
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loaderEstados ? "10" : "12"}>
                        <Form.Control
                          disabled={
                            (!edit ||
                              loaderEstados ||
                              estadoOptions.length === 0 ||
                              (edit &&
                                editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                  "cerrado") ||
                              // (userRoles.length > 0 &&
                              //   !(
                              //     userRoles.includes("administrador") ||
                              //     userRoles.includes(
                              //       "Responsable_Seleccion_Contratacion"
                              //     )
                              //   ))
                              !(
                                view === "administrador" ||
                                view === "Responsable_Seleccion_Contratacion"
                              ) ||
                              props.match.params.type ===
                                "plazas-no-vacantes") &&
                            !userRoles.includes("administrador")
                          }
                          as="select"
                          id="estado"
                          name="estado"
                          className="col rounded-pill"
                          onBlur={handleBlur("estado")}
                          value={values.estado}
                          onChange={handleChange}
                          isValid={touched.estado && !errors.estado}
                          isInvalid={touched.estado && !!errors.estado}
                        >
                          {estadoOptions &&
                            estadoOptions.length > 0 &&
                            estadoOptions.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.label}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loaderEstados && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.estado && errors.estado && (
                      <Col>
                        <small className="text-danger">{errors.estado}</small>
                      </Col>
                    )}
                    {!!estadosFalla && (
                      <Col>
                        <small className="text-danger">**{estadosFalla}</small>
                      </Col>
                    )}
                    {!loaderEstados && estados && estados.count === 0 && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron estados
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Plan de Inducción
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.File
                          multiple
                          id="plan_induccion"
                          name="plan_induccion"
                          className="col position-relative my-2"
                          disabled={
                            (edit &&
                              editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado") ||
                            props.match.params.type === "plazas-no-vacantes"
                          }
                          value={values.plan_induccion}
                          onChange={handleChange}
                          onBlur={handleBlur("plan_induccion")}
                          isValid={
                            touched.plan_induccion && !errors.plan_induccion
                          }
                          isInvalid={
                            touched.plan_induccion && !!errors.plan_induccion
                          }
                        />
                      </Col>
                    </Row>
                    {touched.plan_induccion && errors.plan_induccion && (
                      <Col>
                        <small className="text-danger">
                          {errors.plan_induccion}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                {edit &&
                  editItem.list_plan_induccion &&
                  editItem.list_plan_induccion.length > 0 && (
                    <>
                      <Row>
                        <Col sm={3}>
                          <p className="text-muted">Documentos actuales</p>
                        </Col>
                        <Col sm={9}>
                          <Row>
                            <Col>
                              <ul className="list-unstyled">
                                {editItem.list_plan_induccion.map(
                                  (url, _index) => (
                                    <>
                                      <li
                                        key={editItem.id}
                                        className="d-flex align-items-center"
                                      >
                                        <Button
                                          size="sm"
                                          className="mx-3 text-info"
                                          variant="link"
                                          type="button"
                                          onClick={() => {
                                            setDownloadEdit(parseInt(index));
                                            setTimeout(() => {
                                              var element =
                                                document.createElement("a");
                                              element.setAttribute(
                                                "href",
                                                `${process.env.REACT_APP_URL}/media/${url.plan_induccion}`
                                              );
                                              element.setAttribute(
                                                "download",
                                                `${url.nombre_archivo}`
                                              );
                                              element.style.display = "none";
                                              document.body.appendChild(
                                                element
                                              );
                                              element.click();
                                              document.body.removeChild(
                                                element
                                              );
                                              setDownloadEdit(null);
                                            }, 500);
                                          }}
                                        >
                                          {downloadEdit !== null &&
                                          parseInt(downloadEdit) ===
                                            parseInt(index) ? (
                                            <Spinner
                                              animation="border"
                                              size="sm"
                                            />
                                          ) : (
                                            url.nombre_archivo
                                          )}
                                        </Button>
                                        <Button
                                          size="sm"
                                          className="text-danger"
                                          variant="link"
                                          type="button"
                                          onClick={() =>
                                            onDeleteUrl(url.id, index, _index)
                                          }
                                        >
                                          <i className="material-icons">
                                            close
                                          </i>
                                        </Button>
                                      </li>
                                    </>
                                  )
                                )}
                              </ul>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                {(edit &&
                  editItem.list_estado[0].nombre_estado.toLowerCase() !==
                    "cerrado") ||
                userRoles.includes("administrador")
                  ? props.match.params.type === "plazas-vacantes" && (
                      <Button
                        className="rounded-pill"
                        disabled={
                          saveLoading ||
                          descriptorValidationLoading ||
                          loading ||
                          !descriptorExist ||
                          !descriptorComplete ||
                          !_funcion ||
                          props.match.params.type === "plazas-no-vacantes"
                        }
                        variant="primary"
                        type="submit"
                      >
                        {saveLoading || loading ? (
                          <Spinner
                            className="mr-2"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : null}
                        Guardar
                      </Button>
                    )
                  : null}
                {!edit && props.match.params.type === "plazas-vacantes" && (
                  <Button
                    className="rounded-pill"
                    disabled={
                      saveLoading ||
                      loading ||
                      !descriptorExist ||
                      !descriptorComplete ||
                      !_funcion ||
                      props.match.params.type === "plazas-no-vacantes"
                    }
                    variant="primary"
                    type="submit"
                  >
                    {saveLoading || descriptorValidationLoading ? (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : null}
                    Guardar
                  </Button>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default RequirementsMonitor;
